import React from 'react';
import 'date-fns';
import UploadForm from './types/UploadForm';
import FavoriteForm from './types/FavoriteForm';
import LinkForm from './types/LinkForm';
import JournalForm from './types/JournalForm';
import ItemForm from './types/ItemForm';
import SurveyForm from "./types/SurveyForm";

const getFormType = (item_data_type) => {
    switch (item_data_type) {
    case 'Upload':
      return UploadForm;
    case 'Favorite':
      return FavoriteForm;
    case 'Link':
      return LinkForm;
    case 'JournalPost':
      return JournalForm;
    case 'SurveyAttempt':
      return SurveyForm;
    default:
      return ItemForm;
  }
};

function ItemTypeForm(props) {
  const { item, itemType, handleItemChange, ...rest } = props;
  const FormType = getFormType(itemType || item.item_data_type);

  return <FormType {...rest} item={item} handleItemChange={handleItemChange}/>;

}

export default ItemTypeForm;
